import { readLinkedProjectJson } from './read-linked-project-json.js'

export function readLinkedProjectId(cwd: string): string | undefined {
  return readLinkedProjectJson(cwd)?.projectId
}
